// src/Components/MobileAppPromo/MobileAppPromo.jsx
import React from 'react';
import { useNavigate } from "react-router-dom";
import './MobileAppPromo.css';

function MobileAppPromo({isLoggedIn}) {
  const navigate = useNavigate();

  const handleRegister = () => {
    navigate("/signUp");
  };

  const handleGoToGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.oxenspace.BeyondschoolsApp",
      "_blank"
    );
  };

  const handleGoToAppStore = () => {
    window.open(
      "https://apps.apple.com/app/idXXXXXXXXX",
      "_blank"
    );
  };

  return (
    <div className="mobile-promo-container">
      <div className="mobile-promo-content">
        <div className="store-icons">
          <img
            src={require('../../Assets/googleplay.png')}
            alt="Google Play"
            className="promo-image"
            onClick={handleGoToGooglePlay}
            style={{ cursor: 'pointer' }}
          />
          {/* <img
            src={require('../../Assets/appstore.png')}
            alt="App Store"
            className="promo-image"
            onClick={handleGoToAppStore}
            style={{ cursor: 'pointer' }}
          /> */}
        </div>

        <h2>Download Our App</h2>
        <p>Learn easily from your phone — access videos, quizzes, and lessons anywhere, anytime!</p>
        <div className="promo-buttons">
          {!isLoggedIn &&  (
          <button className="register-btn" onClick={handleRegister}>
            Get Started Now
          </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default MobileAppPromo;
